var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-combobox",
    _vm._b(
      {
        staticClass: "ma-0 pa-0",
        attrs: { label: "search", multiple: "", outlined: "" },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function({ item, index, selected }) {
              return [
                _c(
                  "v-chip",
                  {
                    attrs: {
                      color: "blue-grey darken-3",
                      dark: "",
                      "input-value": selected,
                      label: "",
                      small: ""
                    }
                  },
                  [
                    _c("span", [_vm._v(_vm._s(item))]),
                    _c(
                      "v-icon",
                      {
                        attrs: { small: "" },
                        on: {
                          click: function($event) {
                            return _vm.deleteItem(index)
                          }
                        }
                      },
                      [_vm._v("$delete")]
                    )
                  ],
                  1
                )
              ]
            }
          }
        ]),
        model: {
          value: _vm.vals,
          callback: function($$v) {
            _vm.vals = $$v
          },
          expression: "vals"
        }
      },
      "v-combobox",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }